var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "bg-white card mb-2" }, [
        _c(
          "div",
          {
            staticClass: "card-body d-flex justify-content-evenly",
            staticStyle: { gap: "1.25rem" },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "my-3" }, [_vm._v(_vm._s(_vm.mainText))]),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "div",
        {
          staticClass:
            "bg-info text-white d-inline-flex align-items-center justify-content-center toast-icon",
        },
        [_c("i", { staticClass: "far fa-file-pdf" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }